import {
  AdminGetUserCommand,
  ListUsersCommand,
  AdminCreateUserCommand,
  SignUpCommand,
  AdminDeleteUserCommand,
  AdminEnableUserCommand,
  AdminDisableUserCommand,
  AdminConfirmSignUpCommand,
  AdminSetUserPasswordCommand,
  AdminResetUserPasswordCommand,
  AdminUpdateUserAttributesCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { cognitoConfigJSON, DEFAULT_EMAIL_VERIFY, ROLES, USER_ATTRIBUTES } from "./cognitoClientProviderHelper";
import { cognitoClientProvider } from "./cognitoClientProviderHelper";
import { generateSecretHash } from "./cognitoClientProviderHelper";

export const signUpUserInPool = async (clientId, username, password, email) => {
  const cognitoClient = await cognitoClientProvider();
  const secretHash = generateSecretHash(cognitoConfigJSON.Username, cognitoConfigJSON.clientId, cognitoConfigJSON.clientSecret);
  const command = new SignUpCommand({
    ClientId: clientId,
    Username: username,
    Password: password,
    SecretHash: secretHash,
    UserAttributes: [{ Name: "email", Value: email }],
  });

  try {
    const response = await cognitoClient.send(command);
    console.log("signUpUserInPool : ", response);
    return response;
  } catch (err) {
    console.error("Signup error:", err);
    throw err;
  }
};

const ADMIN_ACTIONS = {
  LIST_USERS:"LIST_USERS",
  CREATE_USER:"CREATE_USER",
  DELETE_USER:"DELETE_USER",
  USER_ATTRIBUTES:"USER_ATTRIBUTES",
  CONFIRM_USER:"CONFIRM_USER",
  ENABLE_USER:"ENABLE_USER",
  DISABLE_USER:"DISABLE_USER",
  UPDATE_USER:"UPDATE_USER",
  SET_USER_PASSWORD:"SET_USER_PASSWORD",
  RESET_USER_PASSWORD:"RESET_USER_PASSWORD",
}

const adminCognitoActions = async (ACTION, email, temporaryPassword, Role) => {

  const cognitoClient = await cognitoClientProvider();

  var adminActionCommand = null;

  switch (ACTION) {
    case ADMIN_ACTIONS.LIST_USERS:
      //List Users
      adminActionCommand = new ListUsersCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        //Filter: 'custom:role = "admin"',
        // AttributesToGet: ['email'],
        // Limit: 60,
      });
      break;

    case ADMIN_ACTIONS.CREATE_USER:
      //Create User
      adminActionCommand = new AdminCreateUserCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
        TemporaryPassword: temporaryPassword || "nexIntain@1234",
        UserAttributes: [
          { Name: USER_ATTRIBUTES.EMAIL, Value: email },
          { Name: USER_ATTRIBUTES.EMAIL_VERIFIED, Value: DEFAULT_EMAIL_VERIFY },
          { Name: USER_ATTRIBUTES.ROLE, Value: Role || ROLES.SUPER_ADMIN }
        ],
        MessageAction: "SUPPRESS",
      });
      break;

    case ADMIN_ACTIONS.DELETE_USER:
      //Delete User
      adminActionCommand = new AdminDeleteUserCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
      });
      break;

    case ADMIN_ACTIONS.USER_ATTRIBUTES:
      //Get User Info
      adminActionCommand = new AdminGetUserCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
      });
      break;

    case ADMIN_ACTIONS.CONFIRM_USER:
      //Update User Confirmation Status
      adminActionCommand = new AdminConfirmSignUpCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
      });
      break;

    case ADMIN_ACTIONS.ENABLE_USER:
      //Update User Status Enable
      adminActionCommand = new AdminEnableUserCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
      });
      break;

    case ADMIN_ACTIONS.DISABLE_USER:
      //Update User Status Disable
      adminActionCommand = new AdminDisableUserCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
      });
      break;

    case ADMIN_ACTIONS.UPDATE_USER:
      //Update User Attributes
      adminActionCommand = new AdminUpdateUserAttributesCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
        UserAttributes: [
          { Name: USER_ATTRIBUTES.EMAIL_VERIFIED, Value: DEFAULT_EMAIL_VERIFY },
          { Name: USER_ATTRIBUTES.ROLE, Value: Role || ROLES.SUPER_ADMIN },
        ],
      });
      break;

    case ADMIN_ACTIONS.SET_USER_PASSWORD:
      //Add User Password (Status:Force Change Password => Status:Confirmed)
      adminActionCommand = new AdminSetUserPasswordCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
        Password: temporaryPassword,
        Permanent: true
      });
      break;

    case ADMIN_ACTIONS.RESET_USER_PASSWORD:
      //Reset User Password
      adminActionCommand = new AdminResetUserPasswordCommand({
        UserPoolId: cognitoConfigJSON.userPoolId,
        Username: email,
      });
      break;

    default:
      break;
  }

  if(adminActionCommand && ACTION)
  {
    try {
      const response = await cognitoClient.send(adminActionCommand);
      //console.log("Admin Cognito Actions Response : ", response);
      // const enabledAdmins = response.Users.filter(
      //   user => user.Enabled === true && user.UserStatus !== "DISABLED"
      // );
      return response;
    } catch (error) {
      console.error("Admin Cognito Actions Error : ", error);
      throw error;
    }
  }
};

export { adminCognitoActions,ADMIN_ACTIONS }


/** AdminCreateUserCommand */
//   {
//     "$metadata": {
//         "httpStatusCode": 200,
//         "requestId": "ab1422cd-ee23-412b-9eb5-b96a029f50dd",
//         "attempts": 1,
//         "totalRetryDelay": 0
//     },
//     "User": {
//         "Attributes": [
//             {
//                 "Name": "email",
//                 "Value": "rahul1@nexintain.com"
//             },
//             {
//                 "Name": "email_verified",
//                 "Value": "true"
//             },
//             {
//                 "Name": "sub",
//                 "Value": "a1d3ad0a-40f1-7080-3979-18da6ed4f7bb"
//             }
//         ],
//         "Enabled": true,
//         "UserCreateDate": "2025-05-16T04:54:09.432Z",
//         "UserLastModifiedDate": "2025-05-16T04:54:09.432Z",
//         "UserStatus": "FORCE_CHANGE_PASSWORD",
//         "Username": "a1d3ad0a-40f1-7080-3979-18da6ed4f7bb"
//     }
// }


/** AdminGetUserCommand */
// {
//     "$metadata": {
//         "httpStatusCode": 200,
//         "requestId": "af0ebf28-38b0-4937-b356-bf53aa187be4",
//         "attempts": 1,
//         "totalRetryDelay": 0
//     },
//     "Enabled": true,
//     "UserAttributes": [
//         {
//             "Name": "email",
//             "Value": "rahul1@nexintain.com"
//         },
//         {
//             "Name": "email_verified",
//             "Value": "true"
//         },
//         {
//             "Name": "sub",
//             "Value": "a1d3ad0a-40f1-7080-3979-18da6ed4f7bb"
//         }
//     ],
//     "UserCreateDate": "2025-05-16T04:54:09.432Z",
//     "UserLastModifiedDate": "2025-05-16T04:54:09.432Z",
//     "UserStatus": "FORCE_CHANGE_PASSWORD",
//     "Username": "a1d3ad0a-40f1-7080-3979-18da6ed4f7bb"
// }


/** AdminDeleteUserCommand */
// {
//     "$metadata": {
//         "httpStatusCode": 200,
//         "requestId": "49c3a64f-fb30-4f91-92c9-6c47f01b9e73",
//         "attempts": 1,
//         "totalRetryDelay": 0
//     }
// }


/** ListUsersCommand */
// {
//     "$metadata": {
//         "httpStatusCode": 200,
//         "requestId": "27742d4d-4ad1-44b6-a30f-cdc020b23f83",
//         "attempts": 1,
//         "totalRetryDelay": 0
//     },
//     "Users": [
//         {
//             "Attributes": [
//                 {
//                     "Name": "email",
//                     "Value": "rahul@nexintain.com"
//                 },
//                 {
//                     "Name": "email_verified",
//                     "Value": "true"
//                 },
//                 {
//                     "Name": "sub",
//                     "Value": "21b37d1a-c0a1-7075-2141-822062ee203c"
//                 }
//             ],
//             "Enabled": true,
//             "UserCreateDate": "2025-05-15T09:15:39.081Z",
//             "UserLastModifiedDate": "2025-05-15T09:16:09.156Z",
//             "UserStatus": "CONFIRMED",
//             "Username": "21b37d1a-c0a1-7075-2141-822062ee203c"
//         },
//         {
//             "Attributes": [
//                 {
//                     "Name": "email",
//                     "Value": "parteekrana85@gmail.com"
//                 },
//                 {
//                     "Name": "email_verified",
//                     "Value": "true"
//                 },
//                 {
//                     "Name": "sub",
//                     "Value": "71337daa-a061-70b9-f06e-3613805a3e08"
//                 }
//             ],
//             "Enabled": true,
//             "UserCreateDate": "2025-05-14T12:10:15.231Z",
//             "UserLastModifiedDate": "2025-05-14T12:35:53.121Z",
//             "UserStatus": "CONFIRMED",
//             "Username": "71337daa-a061-70b9-f06e-3613805a3e08"
//         },
//         {
//             "Attributes": [
//                 {
//                     "Name": "email",
//                     "Value": "parteekrana@gmail.com"
//                 },
//                 {
//                     "Name": "email_verified",
//                     "Value": "false"
//                 },
//                 {
//                     "Name": "sub",
//                     "Value": "81035daa-5011-702e-4b98-ac1586bccd09"
//                 }
//             ],
//             "Enabled": true,
//             "UserCreateDate": "2025-05-14T12:07:29.497Z",
//             "UserLastModifiedDate": "2025-05-14T12:07:29.497Z",
//             "UserStatus": "UNCONFIRMED",
//             "Username": "81035daa-5011-702e-4b98-ac1586bccd09"
//         },
//         {
//             "Attributes": [
//                 {
//                     "Name": "email",
//                     "Value": "suhail@nexintain.com"
//                 },
//                 {
//                     "Name": "email_verified",
//                     "Value": "true"
//                 },
//                 {
//                     "Name": "sub",
//                     "Value": "c1f37d0a-c051-709e-8788-778197a475e0"
//                 }
//             ],
//             "Enabled": true,
//             "UserCreateDate": "2025-05-15T09:15:50.175Z",
//             "UserLastModifiedDate": "2025-05-15T09:16:35.380Z",
//             "UserStatus": "CONFIRMED",
//             "Username": "c1f37d0a-c051-709e-8788-778197a475e0"
//         },
//         {
//             "Attributes": [
//                 {
//                     "Name": "email",
//                     "Value": "parth.k@nexintain.com"
//                 },
//                 {
//                     "Name": "sub",
//                     "Value": "f1a3dd9a-b071-70fb-5f29-f3743da46dd5"
//                 }
//             ],
//             "Enabled": true,
//             "UserCreateDate": "2025-05-14T05:38:48.804Z",
//             "UserLastModifiedDate": "2025-05-14T05:39:58.935Z",
//             "UserStatus": "CONFIRMED",
//             "Username": "f1a3dd9a-b071-70fb-5f29-f3743da46dd5"
//         }
//     ]
// }